import { ITask } from "dto/ITask";

export type { FC } from "react";

export interface Props {
  isDesk?: boolean;
  setTask: (task: ITask) => void;
}

export enum Types {
  ALL,
  READY,
  NOT_READY,
}
